<script lang="ts" setup>
import { TrackingService } from '@/client/services'

function onClickLogo(): void {
  TrackingService.sendEvent('click:ロゴ')
}
</script>

<template>
  <router-link to="/campaigns" @click="onClickLogo">
    <img src="@/client/assets/images/atelu_logo_white.svg" class="logo" />
  </router-link>
</template>

<style lang="scss" scoped>
.logo {
  width: 100%;
  max-width: 100%;
  height: 30px;

  &:hover {
    opacity: 0.8;
  }
}
</style>
